import { Button as MUIButton } from '@mui/material';
import React, { PropsWithChildren, RefObject } from 'react';
import FontAwesome from 'react-fontawesome';

import { normalizeFontAwesomeIRI } from '../../lib/iris';

export interface ButtonProps {
  active?: boolean;
  ariaLabel?: string;
  buttonRef?: RefObject<HTMLButtonElement>;
  color?: string;
  disabled?: boolean;
  href?: string;
  icon?: string;
  loading?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  small?: boolean;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'outlined' | 'text';
}

const Button = (props: PropsWithChildren<ButtonProps>) => {
  const { active, ariaLabel, buttonRef, children, color, icon, small, type, variant, ...otherProps } = props;

  return (
    <MUIButton
      aria-label={ariaLabel}
      aria-pressed={active}
      loadingPosition="start"
      ref={buttonRef}
      size={small ? 'small' : undefined}
      startIcon={icon && <FontAwesome name={normalizeFontAwesomeIRI(icon)} />}
      sx={{
        '& .MuiButton-startIcon': children ? {} : { marginRight: 0 },
        ...(color
          ? {
              '--variant-outlinedColor': color,
              '&:hover': {
                '--variant-outlinedBg': color,
                '--variant-outlinedColor': '#FFF',
              },
              // '--variant-containedBg': color,
            }
          : undefined),
      }}
      type={type ?? 'button'}
      variant={variant ?? 'contained'}
      {...otherProps}
    >
      {children}
    </MUIButton>
  );
};

export default Button;
